import { getTeamDisplay, teamFlagMap } from "../functionsSimulator";
import "./winnerDisplay.sass";

export default function WinnerDisplay({ winner, variant = "default" }) {
  const hasWinner = winner && winner !== "TBD";

  if (variant === "champion") {
    const specialFlags = ["UE1", "UE2", "UE3", "UE4", "IC1", "IC2"];
    const rawFlag = teamFlagMap[winner] || (winner ? winner.substring(0, 3).toUpperCase() : null);
    const flag = rawFlag && specialFlags.includes(rawFlag) ? "FIFA" : rawFlag;

    return (
      <div className={`ChampionCard ${hasWinner ? "has-winner" : ""}`}>
        <div className={`${hasWinner ? "bandera-champion_" + flag : "champion-flag-default"}`}></div>
        <span className="ChampionText">{hasWinner ? winner : "PAÍS"}</span>
      </div>
    );
  }

  if (variant === "thirdPlace") {
    const winnerDisplay = hasWinner ? getTeamDisplay(winner) : null;

    return (
      <div className={`ThirdPlaceWinner ${hasWinner ? "" : "placeholder"}`}>
        {hasWinner && winnerDisplay ? (
          <>
            <div className={`bandera-${winnerDisplay.flag} third-place-flag`}></div>
            <span className="ThirdPlaceWinnerName">{winnerDisplay.display}</span>
          </>
        ) : (
          <div className="MatchTeams">
            <div className="MatchCardTeam placeholder">
              <div className="bandera-placeholder third-place-flag"></div>
              <span className="ThirdPlaceWinnerName placeholder-text">PAÍS</span>
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
}